export const getContextTournament = () => {
    let config = sessionStorage.getItem('contextTournament');
    if (config) {
        return JSON.parse(config);
    }
    else {
        let retData = null;
        const request = new XMLHttpRequest();
        request.open("GET", '/api/tournament/contextTournament', false); // `false` makes the request synchronous
        request.send(null);

        if (request.status === 200) {
            if (request.responseText) {
                sessionStorage.setItem('contextTournament', request.responseText)
                retData = JSON.parse(request.responseText)
            }
        }
        return retData;
    }
};

export const setContextTournament = (tournamentCode) => {
    let retData = null;
    const request = new XMLHttpRequest();
    request.open("GET", '/api/tournament/' + encodeURIComponent(tournamentCode), false); // `false` makes the request synchronous
    request.send(null);

    if (request.status === 200) {
        if (request.responseText) {
            sessionStorage.setItem('contextTournament', request.responseText)
            retData = JSON.parse(request.responseText)
        }
    }
    return retData;
};
